import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  msg: '',
}

export const testSlice = createSlice({
  name: 'test',
  initialState,
  reducers: {
    setMsg: (state, action: PayloadAction<{ msg: string }>) => {
      state.msg = action.payload.msg
    },
  },
})

export const { setMsg } = testSlice.actions

export default testSlice.reducer
